<template>
  <div>
    <div class="body-2 flex justify-between gap-24">
      <div>{{ i18n(translations.subtotal) }}</div>
      <div class="ml-24">
        {{ subtotal ? i18n.price(subtotal) : '' }}
      </div>
    </div>

    <div
      v-if="isFlashSalesEnabled && flashSalesDiscount"
      class="mt-8 flex items-center justify-between gap-24"
    >
      <FlashSalesTag
        :icon="IconBoltFilled"
        :label="i18n(translations.flashSalesTag)"
      />
      <div class="text-static-success-hi body-2-bold ml-24">
        -{{ i18n.price(flashSalesDiscount) }}
      </div>
    </div>

    <div v-if="Boolean(serviceFee)" class="mt-8 flex justify-between">
      <ServiceFeeModal />
      <div class="body-2 ml-24" data-qa="service-fee">
        {{ serviceFee ? i18n.price(serviceFee) : '' }}
      </div>
    </div>

    <div v-if="withTax" class="body-2 mt-8 flex justify-between">
      <div>{{ taxTitle }}</div>
      <div class="ml-24" data-qa="tax">
        {{ taxPrice }}
      </div>
    </div>

    <div
      v-if="Boolean(discountPrice) && discountToken"
      class="mt-8 flex justify-between"
    >
      <RevTag class="uppercase" :label="discountToken" variant="success" />
      <div class="text-action-success-hi body-2 ml-24" data-qa="discount">
        -{{ discountPrice }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import ServiceFeeModal from '@backmarket/nuxt-layer-product-modals/ServiceFeeModal.vue'
import FlashSalesTag from '@backmarket/nuxt-layer-recommendation/FlashSalesTag.vue'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevTag } from '@ds/components/Tag'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './SubTotals.translations'
import type { SubTotalsProps } from './SubTotals.types'

const route = useRoute()
const i18n = useI18n()

const props = defineProps<SubTotalsProps>()

const taxTitle = computed(() =>
  route.name === CHECKOUT.PAYMENT
    ? i18n(translations.tax)
    : i18n(translations.estimatedTax),
)

const taxPrice = computed(() =>
  isEmpty(props.tax) ? i18n(translations.pending) : i18n.price(props.tax),
)
const experiments = useExperiments()

const isFlashSalesEnabled = experiments['experiment.flashSales'] === 'enabled'
</script>
